<pmt-action-modal [title]="title" cancelButtonText="modal.closeButton" class="custom-modal-limiter" [onlyCancel]="true">
    <div class="d-flex flex-column gap-3">
        <ng-container *ngFor=" let registrationDetail of registrationDetails">
            <div class="d-flex flex-column gap-2">
                <app-page-divider [icon]="registrationDetail.iconCode ?? 'fa-solid fa-circle-info'"
                    [text]="registrationDetail.questionTitle"></app-page-divider>
                <div class="alert alert-secondary fs-4 p-2"
                    *ngIf="registrationDetail.question != registrationDetail.questionTitle">
                    <markdown class="variable-binding" [data]="registrationDetail.question"></markdown>
                </div>
                <p>{{registrationDetail.answer}}</p>
            </div>
        </ng-container>
    </div>
</pmt-action-modal>